import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataEntity, Entity, ENUM_ACTIONS, ERRORS_FORM, Options, Property, PropertyTypes, ValidationType } from '@Interfaces/index';
import { AdfiGraphqlService } from '@services/adfi-graphql.service';
import { AdfiGrowlService } from '@services/adfi-growl.service';
import { AdfiRest } from '@services/adfi-rest';
import { AdfiService } from '@services/adfi-service';
import { LoadingService } from '@services/loading.service';
import { ConfirmDialogComponent, ConfirmDialogData } from '../confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-validate',
  templateUrl: './validate.component.html',
  styleUrls: ['./validate.component.scss']
})
export class ValidateComponent implements OnInit {
  TYPES = PropertyTypes;
  displayTitle = true;
  configTable: Entity;
  columns: Property[];
  columnsView: Property[];
  classLabel = 'col-6 col-md-5';
  classContent = 'col-6 col-md-7';
  item: any;
  loadingData = true;
  entityForm: FormGroup;
  titleForm = '';
  @Output() postSave = new EventEmitter<any>();

  constructor(private loadingService: LoadingService,
    private adfiService: AdfiService,
    private adfiGrowl: AdfiGrowlService,
    private adfiGraphql: AdfiGraphqlService,
    @Inject(MAT_DIALOG_DATA) public data: DataEntity,
    public dialogRef: MatDialogRef<ValidateComponent>,
    private matDialog: MatDialog,
  ) { }

  ngOnInit() {
    this.loadConfig();
  }

  private loadConfig() {
    this.loadingService.show();
    this.titleForm = this.data.customTitle;
    this.adfiService.post<Entity>(AdfiRest.getConfigData,
      { entity: this.data.entityName, module: this.data.module })
      .subscribe((value: Entity) => {
        this.configTable = value;
        this.columnsView = this.configTable.properties;
        this.columns = this.configTable.properties.filter(
          prop => {
            return this.data.mustValidate === prop.fieldName;
          }
        );
        this.configForm();

      }, (e) => {
        this.adfiGrowl.errorMessage(e);
        this.loadingService.hide();
      });
    this.loadingData = false;
    this.loadingService.hide();

  }
  private configForm(row?: any) {
    this.entityForm = new FormGroup({});
    this.columns.forEach((value, index) => {
      this.entityForm.addControl(value.fieldName, new FormControl('', [Validators.required, Validators.min(100000)]));
    });
  }

  validate(form: FormGroupDirective) {
    this.loadingService.show();
    const next = (data) => {
      if (data.length > 0) {
        this.item = data[0];
      } else {
        const customData: any = { document: this.entityForm.get(this.data.mustValidate).value };
        this.dialogRef.close({
          entityName: this.data.entityName,
          module: this.data.module,
          customData,
        } as DataEntity);


      }
      this.loadingService.hide();
    };
    const error = (e) => {
      this.adfiGrowl.errorMessage(e, 'Error al cargar los registros');
    };
    this.adfiGraphql.getEntity(this.configTable.plural, 'document name charge attendantName attendantDocument centroCosto { _id deDescripcion }', 1, `${this.data.mustValidate}: ${form.control.get(this.data.mustValidate).value}`, { next, error });

  }

  getDataDropdown(field: Property) {
    const val = field.options[this.TYPES.DROPDOWN].find(value =>
      value.key === this.item[field.fieldName]
    );
    return val ? val.value : undefined;
  }
  changeCencos() {
    this.loadingService.show();
    if (this.item.centroCosto._id == this.adfiService.user.centroCosto._id) {
          this.loadingService.hide();
          this.adfiGrowl.info('Información', 'El responsable de bienes ya se encuentra en su institución educativa');
    }else {
    const content = 'El responsable de bienes se encuetra actualemente en <b>' + this.item.centroCosto.deDescripcion + '</b>. ';
    const data: ConfirmDialogData = {
      title: '¿Desea trasladar el responsable de bienes a su Institución Educativa?',
      content,
      action: ENUM_ACTIONS.CREATE
    };
    const dialog = this.matDialog.open(ConfirmDialogComponent, {
      data
    });
    dialog.componentInstance.dialogRef.afterClosed().subscribe(value => {
      if (value) {
        const next = (data) => {
          this.loadingService.hide();
          this.adfiGrowl.success('GUARDADO', 'El registro se ha agregado correctamente');
          this.entityForm.reset();
          this.dialogRef.close(true);
        };
        const error = (err) => {
          this.loadingService.hide();
          this.adfiGrowl.errorMessage(err);
        };
        this.adfiGraphql.updateEntity(this.configTable.entity, {
          id: this.item.id,
          centroCosto: this.adfiService.user.centroCosto.id
        },
          'cencos ',
          { next: next, error: error });
      } else {
        this.loadingService.hide();
      }
    });
    }
  }

   getError(field: Property, form: AbstractControl) {
        if (form.hasError(ERRORS_FORM.REQUIRED)) {
            const validation = field.validations.find(value =>
                value.type === ValidationType.NOT_BLANK || value.type === ValidationType.NOT_NULL);
            return validation ? validation.message : 'Campo requerido';
        }
       
        if (form.hasError(ERRORS_FORM.MIN)) {
            const validationMin = field.validations.find(value => value.type === ValidationType.LENGTH);
            return validationMin ? validationMin.minMessage.replace(/{{\s*limit\s*}}/g, form.errors.min.min) : `El mínimo de caracteres válidos es de ${form.errors.min.min}`;
        }
        return 'Campo no válido';
    }

}
